import { Component } from '@angular/core';

@Component({
  selector: 'app-kontakt',
  templateUrl: './impressum.component.html',
  styleUrls: ['./impressum.component.scss']
})
export class ImpressumComponent {
}
